import { render, staticRenderFns } from "./personalize.vue?vue&type=template&id=e88a30c6&scoped=true"
import script from "./personalize.vue?vue&type=script&lang=js"
export * from "./personalize.vue?vue&type=script&lang=js"
import style0 from "./personalize.vue?vue&type=style&index=0&id=e88a30c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88a30c6",
  null
  
)

export default component.exports